import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthCallbackComponent } from './components';

export const routes: Routes = [
  {
    path: 'oauth-callback/:clientRequestId',
    redirectTo: 'oauth-callback',
    pathMatch: 'full',
  },
  {
    path: 'oauth-callback',
    component: AuthCallbackComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SharedAuthenticationRoutingModule {}
